/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Build_StageInputs */

const en_how_we_work_build_stage = /** @type {(inputs: How_We_Work_Build_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`02 / Build`)
};

const lv_how_we_work_build_stage = /** @type {(inputs: How_We_Work_Build_StageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`02 / Izstrāde`)
};

/**
* | output |
* | --- |
* | "02 / Build" |
*
* @param {How_We_Work_Build_StageInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_build_stage = /** @type {((inputs?: How_We_Work_Build_StageInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Build_StageInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_build_stage(inputs)
	return en_how_we_work_build_stage(inputs)
});